import { render, staticRenderFns } from "./mouthcarimport.vue?vue&type=template&id=98d9a684&"
import script from "./mouthcarimport.vue?vue&type=script&lang=js&"
export * from "./mouthcarimport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports